(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arcane-collection-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.arcane-plp');
    if (!sections.length) return;
    if (typeof IntersectionObserver === 'undefined') {
      // Fallback: just reveal everything immediately
      document.querySelectorAll('.arcane-plp .arcane-reveal-up').forEach(function(el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    var observer = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });

    sections.forEach(function(section) {
      section.querySelectorAll('.arcane-reveal-up').forEach(function(el) {
        observer.observe(el);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arcane-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-arcane-qadd]').forEach(function(btn) {
      if (btn.dataset.init) return;
      btn.dataset.init = '1';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (btn.disabled) return;
        var variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId) return;

        btn.disabled = true;
        var origHTML = btn.innerHTML;
        btn.innerHTML = 'Adding&hellip; <span class="arcane-btn__arrow" aria-hidden="true">&rarr;</span>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.status && data.status >= 400) throw new Error(data.description || 'Error');
          btn.innerHTML = 'Added to archive <span class="arcane-btn__arrow" aria-hidden="true">&rarr;</span>';
          btn.classList.add('is-added');
          // Update any cart count bubble
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var els = document.querySelectorAll('[data-cart-bubble-count],[data-cart-count],.cart-count-bubble span');
              els.forEach(function(el) { el.textContent = cart.item_count; });
              document.dispatchEvent(new CustomEvent('arcane:cart:updated', { detail: cart }));
            })
            .catch(function() {});
          setTimeout(function() {
            btn.innerHTML = origHTML;
            btn.disabled = false;
            btn.classList.remove('is-added');
          }, 2600);
        })
        .catch(function() {
          btn.innerHTML = 'Try again <span class="arcane-btn__arrow" aria-hidden="true">&rarr;</span>';
          btn.classList.add('is-error');
          setTimeout(function() {
            btn.innerHTML = origHTML;
            btn.disabled = false;
            btn.classList.remove('is-error');
          }, 2200);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function(e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arcane-commissions"] && !Shopify.designMode) return;
  try {
    
(function () {
  // If the form just posted, bring the confirmation into view.
  var msg = document.querySelector('.arcane-commissions__msg');
  if (msg && window.location.hash === '#CommissionForm') {
    msg.scrollIntoView({ block: 'center' });
    msg.focus({ preventScroll: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arcane-folio"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__arcaneFolioInit) return;
  window.__arcaneFolioInit = true;

  var reduced = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  var MAX_SCALE_DELTA = 0.035; /* 1 -> 0.965 */
  var MAX_DIM = 0.35;

  function initStack(stack) {
    if (stack.dataset.folioReady) return;
    stack.dataset.folioReady = 'true';

    var wraps = Array.prototype.slice.call(
      stack.querySelectorAll('.arcane-folio__plate-wrap')
    );
    if (wraps.length < 2) return;

    var cards = wraps.map(function (w) {
      return w.querySelector('.arcane-folio__plate');
    });
    var dims = wraps.map(function (w) {
      return w.querySelector('.arcane-folio__dim');
    });

    var ticking = false;

    function clearStyles() {
      cards.forEach(function (card, i) {
        if (card) card.style.transform = '';
        if (dims[i]) dims[i].style.opacity = '';
      });
    }

    function update() {
      ticking = false;

      if (!document.body.contains(stack)) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        return;
      }

      if ((reduced && reduced.matches) || window.innerWidth < 750) {
        clearStyles();
        return;
      }

      for (var i = 0; i < wraps.length - 1; i++) {
        var rect = wraps[i].getBoundingClientRect();
        var next = wraps[i + 1].getBoundingClientRect();
        if (!rect.height) continue;

        var progress = (rect.bottom - next.top) / rect.height;
        progress = Math.max(0, Math.min(1, progress));

        if (cards[i]) {
          cards[i].style.transform =
            'scale(' + (1 - MAX_SCALE_DELTA * progress).toFixed(4) + ')';
        }
        if (dims[i]) {
          dims[i].style.opacity = (MAX_DIM * progress).toFixed(3);
        }
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (reduced && reduced.addEventListener) {
      reduced.addEventListener('change', onScroll);
    }
    update();
  }

  function arm(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-arcane-folio]').forEach(initStack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arm(); });
  } else {
    arm();
  }

  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arcane-library"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.arcane-library');
    if (!sections.length) return;
    if (typeof IntersectionObserver === 'undefined') {
      document.querySelectorAll('.arcane-library .arcane-reveal-up').forEach(function(el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    var observer = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });

    sections.forEach(function(section) {
      section.querySelectorAll('.arcane-reveal-up').forEach(function(el) {
        observer.observe(el);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arcane-lookbook"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || typeof IntersectionObserver === 'undefined') return;

  var rings = document.querySelectorAll('.afr-ring');
  if (!rings.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var ring = entry.target.querySelector('.afr-ring');
      if (ring) ring.classList.add('is-drawn');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.4 });

  document.querySelectorAll('.arcane-fieldrecords__circle').forEach(function (el) {
    io.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arcane-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.arcane-pdp');

    // Reveal-on-scroll
    if (typeof IntersectionObserver !== 'undefined') {
      const revealObserver = new IntersectionObserver(function(entries, obs) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
      sections.forEach(function(section) {
        section.querySelectorAll('.arcane-reveal-up').forEach(function(el) {
          revealObserver.observe(el);
        });
      });
    } else {
      document.querySelectorAll('.arcane-pdp .arcane-reveal-up').forEach(function(el) {
        el.classList.add('is-revealed');
      });
    }

    sections.forEach(function(section) {
      const slides = section.querySelectorAll('[data-arcane-pdp-slide]');
      const dots = section.querySelectorAll('[data-arcane-pdp-dot]');
      const prevBtn = section.querySelector('[data-arcane-pdp-prev]');
      const nextBtn = section.querySelector('[data-arcane-pdp-next]');
      const mediaMain = section.querySelector('[data-arcane-pdp-main]');
      let currentIdx = 0;
      const total = slides.length;

      function goTo(idx) {
        currentIdx = ((idx % total) + total) % total;
        slides.forEach(function(s) {
          s.classList.toggle('is-active', parseInt(s.dataset.index, 10) === currentIdx);
        });
        dots.forEach(function(d) {
          const active = parseInt(d.dataset.index, 10) === currentIdx;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.dataset.index, 10));
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIdx + 1); });

      if (mediaMain && total > 1) {
        var touchStartX = 0;
        mediaMain.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        mediaMain.addEventListener('touchend', function(e) {
          var dx = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(dx) > 40) goTo(currentIdx + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }

      const form = section.querySelector('.arcane-pdp__form');
      if (!form) return;

      const qtyInput = section.querySelector('[data-arcane-pdp-qty]');
      const qtyDecr = section.querySelector('[data-arcane-pdp-qty-decr]');
      const qtyIncr = section.querySelector('[data-arcane-pdp-qty-incr]');
      if (qtyInput && qtyDecr && qtyIncr) {
        qtyDecr.addEventListener('click', function() {
          const v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
          qtyInput.value = v;
        });
        qtyIncr.addEventListener('click', function() {
          const v = parseInt(qtyInput.value, 10) + 1;
          qtyInput.value = v;
        });
      }

      const variantInput = section.querySelector('[data-arcane-pdp-variant-id]');
      const atcBtn = section.querySelector('[data-arcane-pdp-atc]');
      const atcLabel = section.querySelector('[data-arcane-pdp-atc-label]');
      const priceWrap = section.querySelector('[data-arcane-pdp-price]');
      const optionInputs = section.querySelectorAll('[data-arcane-pdp-option]');
      const productHandle = section.dataset.productHandle;

      function getSelectedOptions() {
        const opts = [];
        const grouped = {};
        optionInputs.forEach(function(input) {
          if (input.checked) {
            grouped[input.dataset.optionIndex] = input.dataset.optionValue;
          }
        });
        Object.keys(grouped).sort().forEach(function(k) { opts.push(grouped[k]); });
        return opts;
      }

      function updateSelection() {
        if (!window.ARCANE_PDP_VARIANTS) return;
        const selected = getSelectedOptions();
        if (selected.length === 0) return;
        const sectionKey = section.dataset.arcaneSectionId;
        const match = window.ARCANE_PDP_VARIANTS[sectionKey].find(function(v) {
          return v.options.every(function(opt, i) { return opt === selected[i]; });
        });
        if (!match) return;
        if (variantInput) variantInput.value = match.id;
        if (priceWrap) {
          const priceFmt = match.price_formatted;
          const compareFmt = match.compare_formatted;
          let priceHTML;
          if (compareFmt && match.compare_at_price > match.price) {
            priceHTML = '<s class="arcane-pdp__price-was">' + compareFmt + '</s>' +
              '<strong class="arcane-pdp__price-now">' + priceFmt + '</strong>';
          } else {
            priceHTML = '<strong class="arcane-pdp__price-now">' + priceFmt + '</strong>';
          }
          // Rebuild the edition marker. Metafield-driven editions (data-edition-fixed)
          // are one ledger per design — variant changes never alter them, so the
          // server-rendered span is preserved as-is. Otherwise mirror the server-side
          // inventory logic: running number only when tracked and within the edition.
          let editionHTML;
          if (priceWrap.dataset.editionFixed) {
            const existing = priceWrap.querySelector('.arcane-pdp__edition');
            editionHTML = existing ? existing.outerHTML : '';
          } else {
            const editionSize = parseInt(priceWrap.dataset.editionSize, 10) || 120;
            const inv = match.inventory;
            if (match.tracked === 'shopify' && inv > 0 && inv <= editionSize) {
              const no = String(editionSize - inv + 1).padStart(3, '0');
              editionHTML = '<span class="arcane-pdp__edition">— Nº ' + no + ' of ' + editionSize + '</span>';
            } else if (match.tracked === 'shopify' && inv <= 0) {
              editionHTML = '<span class="arcane-pdp__edition arcane-pdp__edition--closed">— Edition closed</span>';
            } else {
              editionHTML = '<span class="arcane-pdp__edition">— Edition of ' + editionSize + '</span>';
            }
          }
          priceWrap.innerHTML = priceHTML + editionHTML;
        }
        if (atcBtn && atcLabel) {
          atcBtn.disabled = !match.available;
          atcLabel.textContent = match.available ? (atcBtn.dataset.labelAvailable || 'Add to cart') : (atcBtn.dataset.labelSoldOut || 'Sold out');
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
        let mediaId = match.featured_media_id;
        if (!mediaId) {
          const sibling = window.ARCANE_PDP_VARIANTS[sectionKey].find(function(v) {
            return v.featured_media_id && v.options[0] === match.options[0];
          });
          if (sibling) mediaId = sibling.featured_media_id;
        }
        if (mediaId) {
          slides.forEach(function(s) {
            if (parseInt(s.dataset.mediaId, 10) === mediaId) {
              goTo(parseInt(s.dataset.index, 10));
            }
          });
        }
      }

      optionInputs.forEach(function(input) {
        input.addEventListener('change', updateSelection);
      });
    });

    // Sticky mobile ATC bar
    (function() {
      if (!window.matchMedia('(max-width: 880px)').matches) return;
      var section = document.querySelector('.arcane-pdp');
      if (!section) return;
      var sticky = section.querySelector('[data-arcane-pdp-sticky]');
      var mainAtc = section.querySelector('[data-arcane-pdp-atc]');
      var stickyBtn = section.querySelector('[data-arcane-sticky-atc]');
      var stickyPrice = section.querySelector('[data-arcane-sticky-price]');
      var form = section.querySelector('.arcane-pdp__form');
      if (!sticky || !mainAtc) return;

      // Show/hide sticky bar based on main ATC visibility
      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              sticky.classList.remove('is-visible');
              sticky.setAttribute('aria-hidden', 'true');
            } else if (entry.boundingClientRect.top > 0) {
              sticky.classList.add('is-visible');
              sticky.setAttribute('aria-hidden', 'false');
            }
          });
        }, { threshold: 0 });
        io.observe(mainAtc);
      }

      // Mirror availability from main ATC to sticky ATC
      if (stickyBtn && mainAtc) {
        var availObs = new MutationObserver(function() {
          stickyBtn.disabled = mainAtc.disabled;
          var labelEl = stickyBtn.firstChild;
          if (labelEl) {
            labelEl.textContent = mainAtc.disabled ? 'Sold out' : 'Add to cart';
          }
        });
        availObs.observe(mainAtc, { attributes: true, attributeFilter: ['disabled'] });
      }

      // Mirror price changes from variant picker
      var priceWrap = section.querySelector('[data-arcane-pdp-price]');
      if (priceWrap && stickyPrice) {
        var priceObs = new MutationObserver(function() {
          var now = priceWrap.querySelector('.arcane-pdp__price-now');
          if (now) stickyPrice.textContent = now.textContent;
        });
        priceObs.observe(priceWrap, { childList: true, subtree: true });
      }

      // Sticky ATC click submits the main product form
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function() {
          if (stickyBtn.disabled) return;
          stickyBtn.disabled = true;
          var orig = stickyBtn.innerHTML;
          stickyBtn.textContent = 'Adding…';
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            form.submit();
          }
          setTimeout(function() {
            stickyBtn.innerHTML = orig;
            stickyBtn.disabled = false;
          }, 2200);
        });
      }
    })();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arcane-theory-essay"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__arcaneEssayInit) return;
    window.__arcaneEssayInit = true;

    var BRAND_CURVE = 'cubic-bezier(.2,.7,.2,1)';
    var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---- Letter-by-letter title splitter ----
    function splitTitle(el) {
      if (el.dataset.arcaneSplitDone === '1') return;
      el.dataset.arcaneSplitDone = '1';
      var text = el.textContent;
      el.textContent = '';
      var perLetter = 30; // ms
      var startDelay = 350; // ms — after curtain + inner-enter
      for (var i = 0; i < text.length; i++) {
        var ch = text.charAt(i);
        var span = document.createElement('span');
        span.className = 'arcane-essay__title-char';
        span.textContent = ch === ' ' ? ' ' : ch;
        span.style.setProperty('--d', (startDelay + i * perLetter) + 'ms');
        if (ch === ' ') span.style.marginRight = '0.18em';
        el.appendChild(span);
      }
    }

    // ---- Theorem-diagram self-draw on scroll ----
    function initTheoremDraw(svg) {
      if (svg.dataset.arcaneEssayTheoremInit === '1') return;
      svg.dataset.arcaneEssayTheoremInit = '1';

      var allShapes = svg.querySelectorAll('circle, polygon, line, path, rect');
      var drawables = [];
      var fadeShapes = [];
      allShapes.forEach(function (el) {
        if (el.getAttribute('stroke') === 'none') {
          fadeShapes.push(el);
        } else {
          drawables.push(el);
        }
      });
      var labels = svg.querySelectorAll('text');

      drawables.forEach(function (el) {
        var len = 800;
        try { if (el.getTotalLength) { len = el.getTotalLength(); } } catch (e) {}
        el.style.strokeDasharray = len;
        el.style.strokeDashoffset = len;
        el.style.transition = 'stroke-dashoffset 1.6s ' + BRAND_CURVE;
      });
      fadeShapes.forEach(function (el) {
        el.style.opacity = '0';
        el.style.transition = 'opacity 1s ' + BRAND_CURVE;
      });
      labels.forEach(function (el) {
        el.style.opacity = '0';
        el.style.transition = 'opacity 1s ' + BRAND_CURVE;
      });

      if (REDUCED || typeof IntersectionObserver === 'undefined') {
        drawables.forEach(function (el) { el.style.strokeDashoffset = '0'; });
        fadeShapes.forEach(function (el) { el.style.opacity = '1'; });
        labels.forEach(function (el) { el.style.opacity = '1'; });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          drawables.forEach(function (el, i) {
            setTimeout(function () { el.style.strokeDashoffset = '0'; }, i * 70);
          });
          var fadeStart = drawables.length * 70 + 500;
          fadeShapes.forEach(function (el, i) {
            setTimeout(function () { el.style.opacity = '1'; }, fadeStart + i * 220);
          });
          var labelStart = fadeStart + fadeShapes.length * 220 + 240;
          labels.forEach(function (el, i) {
            setTimeout(function () { el.style.opacity = '1'; }, labelStart + i * 280);
          });
          io.unobserve(svg);
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -120px 0px' });
      io.observe(svg);
    }

    // ---- Self-drawing axiom hairlines ----
    function armAxioms(scope) {
      var nodes = (scope || document).querySelectorAll('.arcane-essay__axiom:not(.is-visible)');
      if (!nodes.length) return;
      if (REDUCED || typeof IntersectionObserver === 'undefined') {
        nodes.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -80px 0px' });
      nodes.forEach(function (el) { io.observe(el); });
    }

    // ---- Pull-quote scale-in ----
    function armPullQuotes(scope) {
      var nodes = (scope || document).querySelectorAll('.arcane-essay__pull-quote:not(.is-visible)');
      if (!nodes.length) return;
      if (REDUCED || typeof IntersectionObserver === 'undefined') {
        nodes.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4, rootMargin: '0px 0px -100px 0px' });
      nodes.forEach(function (el) { io.observe(el); });
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-arcane-split-letters]').forEach(splitTitle);
      root.querySelectorAll('.arcane-essay__figure svg').forEach(initTheoremDraw);
      armAxioms(root);
      armPullQuotes(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arcane-theory"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTheoryDiagram(scope) {
    var root = scope || document;
    var diagrams = root.querySelectorAll('[data-arcane-theory-diagram]');
    if (!diagrams.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    diagrams.forEach(function (svg) {
      if (svg.dataset.init) return;
      svg.dataset.init = '1';

      var strokes  = svg.querySelectorAll('circle[stroke], polygon, line[stroke]');
      var fades    = svg.querySelectorAll('.atd-fade');
      var labels   = svg.querySelectorAll('.atd-label');
      var ticks    = svg.querySelectorAll('.atd-ticks');

      strokes.forEach(function (el) {
        var len = 800;
        try { if (el.getTotalLength) len = el.getTotalLength(); } catch (e) {}
        el.style.strokeDasharray  = len;
        el.style.strokeDashoffset = len;
      });

      if (reduced) {
        strokes.forEach(function (el) { el.style.strokeDashoffset = 0; });
        fades.forEach(function (el)   { el.style.opacity = 1; });
        labels.forEach(function (el)  { el.style.opacity = 1; });
        ticks.forEach(function (el)   { el.style.opacity = 1; });
        return;
      }

      if (typeof IntersectionObserver === 'undefined') {
        strokes.forEach(function (el) { el.style.strokeDashoffset = 0; });
        fades.forEach(function (el)   { el.style.opacity = 1; });
        labels.forEach(function (el)  { el.style.opacity = 1; });
        ticks.forEach(function (el)   { el.style.opacity = 1; });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          strokes.forEach(function (el, i) {
            setTimeout(function () { el.style.strokeDashoffset = 0; }, i * 55);
          });
          var afterStrokes = strokes.length * 55 + 300;
          ticks.forEach(function (el) {
            setTimeout(function () { el.style.opacity = 1; }, afterStrokes);
          });
          fades.forEach(function (el, i) {
            setTimeout(function () { el.style.opacity = 1; }, afterStrokes + 200 + i * 150);
          });
          labels.forEach(function (el, i) {
            setTimeout(function () { el.style.opacity = 1; }, afterStrokes + 600 + i * 200);
          });
          io.unobserve(svg);
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -80px 0px' });

      io.observe(svg);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTheoryDiagram(); });
  } else {
    initTheoryDiagram();
  }
  document.addEventListener('shopify:section:load', function (e) { initTheoryDiagram(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
